import Storage from './Storage';

class Auth {
  public token;
  public user;

  constructor(
  ) {
    const authInfo = sessionStorage.getItem('authInformation');

    this.token = authInfo
      // ? JSON.parse(authInfo || '{}').token.accessToken
      // : null;
    // this.user = authInfo ? JSON.parse(authInfo || '{}').user : null;
  }

  isLogged() {
    return !!this.token;
  }

  setToken(token: string) {
    this.token = token;
  }

  getToken() {
    return this.token;
  }
  getUser() {
    return this.user;
  }

  clearToken() {
    this.token = null;
    sessionStorage.removeItem('authInformation');
  }
}

export default new Auth();
